// removed by extract-text-webpack-plugin
module.exports = {"downArrowHolder":"_2R1amOfQbkmjF01hKT2bbt","downArrow":"_30JyXh7QnJv6jclYY8y0bt","creatableSelectInput":"mHNEWKZ0s9USoSHnWmN_q"};


//////////////////
// WEBPACK FOOTER
// ./components/bpostSelect.scss
// module id = 1157
// module chunks = 0